import * as React from 'react';
import { PortalSharedSurveyReportView } from '../../../amorg-common';
import { applicationEndpoints } from '../../../amorg-common/applicationEndpoints';
import { portalClientApi } from '../../../api/portalClientApi';
import { Flex } from '../../../designSystem/compositeComponents/FlexHelpers';
import { SingleColumnLayout } from '../../_layouts/SingleColumnLayout';
import { LoadingPageOverlay } from '../../../designSystem/LoadingPageOverlay';
import { PageHeader } from '../../../designSystem/PageHeader';
import { P } from '../../../designSystem/typography/Body';
import { EmployeePageWrapper } from '../../_pageWrappers/EmployeePageWrapper';
import { PortalListRowItem } from '../_components/PortalListRowItem';

export function PortalReportListPage(): JSX.Element
{
    return (
        <EmployeePageWrapper>
            <PortalReportListPageContent />
        </EmployeePageWrapper>
    );
}

function PortalReportListPageContent(): JSX.Element
{
    const [loading, setLoading] = React.useState(true);
    const [reports, setReports] = React.useState<PortalSharedSurveyReportView[]>([]);
    
    React.useEffect(() => {
        const getData = async () => {
            const resources = await portalClientApi.getPortalSharedResources();
            setReports(
                resources.filter((r): r is PortalSharedSurveyReportView => r.resourceType === 'SurveyReport')
                .map(r => ({
                    ...r,
                    surveyEnd: new Date(r.surveyEnd)
                }))
                .sort((a,b) => b.surveyEnd.getTime() - a.surveyEnd.getTime())
            );
            setLoading(false);
        };
        getData();
    }, []);

    return (
        <>
            <PageHeader narrow headerText='Delte rapporter' headerStyle='primary-black' />
        <SingleColumnLayout narrow>
            <>
                <LoadingPageOverlay loading={loading} />

                <Flex flexDirection='column' gap={8} width='100%'>
                {reports.length === 0 && <P>Ingen rapporter er delt</P>}

                {reports.map(r => (
                    <a href={applicationEndpoints.portal_survey_report_portalResourceId.replace(':portalResourceId', r.id)} 
                    style={{ 
                        textDecoration: 'none', 
                        width: '100%' 
                    }} 
                    key={r.id}>
                        <PortalListRowItem
                            key={r.id}
                            title={r.activityTitle + ' - ' + r.segmentViewName}
                            date={`Afsluttet d. ${new Date(r.surveyEnd).toLocaleDateString()}`}
                            icon='arrows_chevron_chevronForward' />
                    </a>
                ))}
                
            </Flex>
            </>
        </SingleColumnLayout>
        </>
    );
}